(() => {
  const qs = (selector, scope = document) => scope.querySelector(selector);
  const qsa = (selector, scope = document) => [...scope.querySelectorAll(selector)];
  const routeRoot = window.Shopify?.routes?.root || '/';
  const strings = window.SKEEZY_STRINGS || {};
  const motion = () => matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
  const formatMoney = (cents) => {
    const decoder = document.createElement('textarea');
    decoder.innerHTML = (window.SKEEZY_MONEY_FORMAT || '${{amount}}').replace(/<[^>]+>/g, '');
    return decoder.value.replace(/\{\{\s*(amount(?:_no_decimals)?(?:_with_(?:comma|space|apostrophe)_separator)?)\s*\}\}/g, (_, token) => {
      const noDecimals = token.includes('no_decimals');
      const comma = token.includes('comma');
      const separator = token.includes('space') ? ' ' : token.includes('apostrophe') ? "'" : comma ? '.' : ',';
      const [whole, fraction] = ((Number(cents) || 0) / 100).toFixed(noDecimals ? 0 : 2).split('.');
      return whole.replace(/\B(?=(\d{3})+(?!\d))/g, separator) + (noDecimals ? '' : `${comma ? ',' : '.'}${fraction}`);
    });
  };
  qsa('[data-product]').forEach((layout) => {
    const form = qs('[data-product-form]', layout);
    const gallery = qs('[data-gallery]', layout);
    const track = gallery ? qs('[data-media-track]', gallery) : null;
    const sticky = qs('[data-sticky-atc]', layout.closest('.product-main') || layout);
    const mediaItems = gallery ? qsa('[data-media]', gallery) : [];
    const markThumb = (id) => {
      if (!gallery) return;
      qsa('[data-thumb]', gallery).forEach((thumb) => {
        const active = thumb.dataset.thumb === String(id);
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-pressed', String(active));
        if (active && thumb.parentElement.scrollWidth > thumb.parentElement.clientWidth) thumb.parentElement.scrollTo({ left: thumb.offsetLeft - thumb.parentElement.offsetLeft - 60, behavior: motion() });
      });
      mediaItems.forEach((media) => {
        const active = media.dataset.media === String(id);
        media.hidden = !active;
        if (!active) qsa('video', media).forEach((video) => { if (!video.paused) video.pause(); });
      });
    };
    const showMedia = (mediaId) => {
      const target = mediaItems.find((media) => media.dataset.media === String(mediaId));
      if (!target) return;
      markThumb(mediaId);
      if (track && track.scrollWidth > track.clientWidth + 4) track.scrollTo({ left: target.offsetLeft - track.offsetLeft, behavior: motion() });
    };
    if (track) {
      let settle;
      track.addEventListener('scroll', () => {
        clearTimeout(settle);
        settle = setTimeout(() => {
          const current = mediaItems.reduce((closest, media) => Math.abs(media.offsetLeft - track.offsetLeft - track.scrollLeft) < Math.abs(closest.offsetLeft - track.offsetLeft - track.scrollLeft) ? media : closest, mediaItems[0]);
          if (current) markThumb(current.dataset.media);
        }, 90);
      }, { passive: true });
    }
    qsa('[data-thumb]', gallery || layout).forEach((thumb, index, thumbs) => {
      thumb.addEventListener('click', () => showMedia(thumb.dataset.thumb));
      thumb.addEventListener('keydown', (event) => {
        let next = index;
        if (event.key === 'ArrowRight') next = (index + 1) % thumbs.length;
        else if (event.key === 'ArrowLeft') next = (index - 1 + thumbs.length) % thumbs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = thumbs.length - 1;
        else return;
        event.preventDefault();
        thumbs[next].focus();
        showMedia(thumbs[next].dataset.thumb);
      });
    });
    window.SkeezyTheme?.paintSwatches(layout);
    if (!form) return;
    let variants;
    try { variants = JSON.parse(qs('[data-variants]', form)?.textContent || '[]'); } catch { return; }
    if (!Array.isArray(variants) || !variants.length) return;
    try {
      const rules = JSON.parse(qs('[data-quantity-rules]', form)?.textContent || '{}');
      variants.forEach((variant) => { variant.quantity_rule = rules[variant.id] || variant.quantity_rule; });
    } catch {}
    const idInput = qs('[data-variant-id]', form);
    if (idInput) idInput.required = false;
    const fallback = qs('[data-variant-fallback]', form);
    if (fallback) fallback.hidden = true;
    const optionSets = qsa('[data-option-index]', form);
    const button = qs('[data-add-to-cart]', form);
    const label = qs('[data-atc-label]', form);
    const stickyButton = sticky ? qs('[data-sticky-submit]', sticky) : null;
    const quantity = qs('[name="quantity"]', form);
    let isSubmitting = false;
    const sizeSets = optionSets.filter((set) => /^(size|length)$/i.test(set.dataset.optionName || '') && qsa('input', set).length > 1);
    const initialUrl = new URL(window.location.href);
    const linkedVariant = variants.find((variant) => String(variant.id) === initialUrl.searchParams.get('variant'));
    if (linkedVariant) optionSets.forEach((set, index) => qsa('input', set).forEach((input) => { input.checked = input.value === linkedVariant.options[index]; }));
    if (!linkedVariant || initialUrl.searchParams.has('choose_size')) sizeSets.forEach((set) => qsa('input', set).forEach((input) => { input.checked = false; }));
    const needsSize = () => sizeSets.some((set) => !qs('input:checked', set));
    const selectedValues = () => optionSets.map((set) => qs('input:checked', set)?.value ?? null);
    const findVariant = () => {
      if (!optionSets.length) return variants.find((variant) => String(variant.id) === String(idInput?.value)) || variants[0];
      const values = selectedValues();
      return variants.find((variant) => values.every((value, index) => variant.options[index] === value));
    };
    const previewVariant = () => {
      const values = selectedValues();
      const fits = (variant) => values.every((value, index) => value === null || variant.options[index] === value);
      return variants.find((variant) => fits(variant) && variant.available) || variants.find(fits);
    };
    const errorBox = qs('[data-product-error]', form);
    const askForSize = () => {
      const set = sizeSets.find((item) => !qs('input:checked', item));
      if (!set) return;
      set.scrollIntoView({ behavior: motion(), block: 'center' });
      set.classList.add('is-asking');
      qs('input:not(:disabled)', set)?.focus({ preventScroll: true });
      if (errorBox) { errorBox.hidden = false; errorBox.textContent = strings.select_size || 'Select a size before adding this item.'; }
    };
    const syncButtons = (variant) => {
      const waiting = !variant && needsSize();
      const text = isSubmitting ? (strings.adding || 'Adding…') : waiting ? (strings.choose_size || 'Select a size') : !variant ? (strings.unavailable || 'Unavailable') : variant.available ? (strings.add_to_bag || 'Add to bag') : (strings.sold_out || 'Sold out');
      [button, stickyButton].filter(Boolean).forEach((element) => { element.disabled = isSubmitting || (!waiting && (!variant || !variant.available)); });
      if (label) label.textContent = text;
      if (stickyButton) stickyButton.textContent = text;
      form.classList.toggle('needs-size', waiting);
    };
    const stickyImage = sticky ? qs('img', sticky) : null;
    const showVariant = (variant) => {
      [qs('[data-atc-price]', form), qs('[data-price]', layout), sticky ? qs('[data-sticky-price]', sticky) : null].filter(Boolean).forEach((element) => { element.textContent = formatMoney(variant.price); });
      const onSale = Number(variant.compare_at_price) > variant.price;
      [qs('[data-compare-price]', layout), sticky ? qs('[data-sticky-compare]', sticky) : null].filter(Boolean).forEach((element) => { element.hidden = !onSale; if (onSale) element.textContent = formatMoney(variant.compare_at_price); });
      const savePct = onSale ? Math.floor((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price) : 0;
      const save = qs('[data-save-badge]', layout);
      if (save) { save.hidden = !onSale; if (onSale) save.textContent = (strings.save_percent || 'Save [percent]%').replace('[percent]', savePct); }
      const stickySave = sticky ? qs('[data-sticky-save]', sticky) : null;
      if (stickySave) { stickySave.hidden = !onSale; if (onSale) stickySave.textContent = `−${savePct}%`; }
      const saleLine = qs('[data-sale-line]', layout);
      if (saleLine) saleLine.hidden = !onSale;
      const saving = saleLine ? qs('[data-sale-saving]', saleLine) : null;
      if (saving && onSale) saving.textContent = (strings.you_save || 'You save [amount]').replace('[amount]', formatMoney(variant.compare_at_price - variant.price));
      const rule = variant.quantity_rule || {};
      if (quantity) {
        quantity.min = Math.max(1, Number(rule.min) || 1);
        quantity.step = Math.max(1, Number(rule.increment) || 1);
        if (rule.max != null) quantity.max = rule.max; else quantity.removeAttribute('max');
        if (Number(quantity.value) < Number(quantity.min)) quantity.value = quantity.min;
      }
      const updateDelivered = () => {
        const delivered = qs('[data-delivered-price]', layout);
        const itemCount = Math.max(1, Number(quantity?.value) || 1);
        const subtotal = variant.price * itemCount;
        if (delivered) delivered.textContent = formatMoney(subtotal + (subtotal < 7000 ? 800 : 0));
        const deliveredLabel = qs('[data-delivered-label]', layout);
        if (deliveredLabel) deliveredLabel.textContent = itemCount > 1 ? (strings.selected_quantity_total || 'Total for selected quantity:') : (strings.single_item_total || 'Single-item delivered total:');
      };
      updateDelivered();
      if (quantity) quantity.oninput = updateDelivered;
      if (quantity) quantity.onchange = updateDelivered;
      if (variant.featured_media?.id) showMedia(variant.featured_media.id);
      if (stickyImage && variant.featured_media?.preview_image?.src) {
        const source = variant.featured_media.preview_image.src;
        stickyImage.removeAttribute('srcset');
        stickyImage.src = `${source}${source.includes('?') ? '&' : '?'}width=120`;
        stickyImage.alt = variant.featured_media.alt || layout.dataset.productTitle || '';
      }
      const stickyVariant = sticky ? qs('[data-sticky-variant]', sticky) : null;
      if (stickyVariant) stickyVariant.textContent = selectedValues().filter(Boolean).join(' / ');
      const colorSet = optionSets.find((set) => /^colou?r$/i.test(set.dataset.optionName || ''));
      const colorNote = qs('[data-color-note]', form);
      if (colorSet && colorNote) {
        const inputs = qsa('input', colorSet);
        const checked = qs('input:checked', colorSet);
        const isDefault = !checked || !inputs.length || checked.value === inputs[0].value;
        const hasImage = !!variant.featured_media?.id;
        colorNote.hidden = isDefault || hasImage;
        const defaultLabel = qs('[data-color-default]', colorNote);
        if (defaultLabel && inputs.length) defaultLabel.textContent = inputs[0].value;
        if (!hasImage && mediaItems[0]) showMedia(mediaItems[0].dataset.media);
      }
    };
    const render = (updateUrl) => {
      optionSets.forEach((set) => {
        const checked = qs('input:checked', set);
        const selectedLabel = qs('[data-option-selected]', set);
        if (selectedLabel) selectedLabel.textContent = checked ? checked.value : (strings.choose || 'Choose');
        if (checked) set.classList.remove('is-asking');
        qsa('.option-chip', set).forEach((chip) => { chip.classList.toggle('is-selected', !!qs('input:checked', chip)); });
      });
      const variant = findVariant();
      if (idInput) idInput.value = variant?.id || '';
      const preview = variant || previewVariant();
      if (preview) showVariant(preview);
      syncButtons(variant);
      if (updateUrl) {
        const url = new URL(window.location.href);
        if (variant) { url.searchParams.set('variant', variant.id); url.searchParams.delete('choose_size'); }
        else url.searchParams.delete('variant');
        window.history.replaceState(window.history.state, '', url);
      }
    };
    optionSets.forEach((set) => set.addEventListener('change', () => {
      if (errorBox) errorBox.hidden = true;
      render(true);
    }));
    render(false);
    if (sticky) {
      document.body.classList.add('has-sticky-atc');
      stickyButton?.addEventListener('click', () => { if (form.requestSubmit) form.requestSubmit(button); else button?.click(); });
      if ('IntersectionObserver' in window && button) {
        new IntersectionObserver((entries) => { entries.forEach((entry) => { sticky.hidden = entry.isIntersecting; }); }, { threshold: 0.2 }).observe(button);
      } else sticky.hidden = false;
    }
    form.addEventListener('submit', async (event) => {
      if (!window.fetch) return;
      event.preventDefault();
      if (needsSize()) { askForSize(); return; }
      const selectedVariant = findVariant();
      if (isSubmitting || !selectedVariant?.available) return;
      if (!form.reportValidity()) return;
      const body = new FormData(form);
      body.set('sections', 'cart-drawer');
      body.set('sections_url', window.location.pathname);
      isSubmitting = true;
      form.setAttribute('aria-busy', 'true');
      syncButtons(selectedVariant);
      const locked = qsa('[data-option-input], [name="quantity"], [data-quantity-change]', form).map((control) => ({ control, disabled: control.disabled }));
      locked.forEach(({ control }) => { control.disabled = true; });
      if (errorBox) errorBox.hidden = true;
      try {
        let added;
        if (window.SkeezyCart?.add) added = await window.SkeezyCart.add(body);
        else {
          const response = await fetch(`${routeRoot}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body });
          const result = await response.json().catch(() => null);
          if (!response.ok) throw new Error(result?.description || result?.message || strings.add_error || 'Could not add this item. Try again.');
          added = result || {};
          const cart = await fetch(`${routeRoot}cart.js`, { headers: { Accept: 'application/json' } }).then((result) => result.ok ? result.json() : null).catch(() => null);
          if (cart) qsa('[data-cart-count]').forEach((count) => { count.textContent = cart.item_count; count.hidden = cart.item_count === 0; });
        }
        if (window.SkeezyCart) window.SkeezyCart.open(added.sections?.['cart-drawer']);
        else window.location.assign(`${routeRoot}cart`);
      } catch (error) {
        if (errorBox) { errorBox.hidden = false; errorBox.textContent = error instanceof TypeError ? (strings.network_error || 'Connection interrupted. Your bag may have changed. Check your bag before trying again.') : error.message; }
      } finally {
        isSubmitting = false;
        form.removeAttribute('aria-busy');
        locked.forEach(({ control, disabled }) => { control.disabled = disabled; });
        syncButtons(findVariant());
      }
    });
  });
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-open-details]');
    const details = link && document.getElementById(link.dataset.openDetails);
    if (!details) return;
    event.preventDefault();
    details.open = true;
    details.scrollIntoView({ behavior: motion(), block: 'start' });
    details.querySelector('summary')?.focus({ preventScroll: true });
  });
  const initialDetails = document.getElementById(location.hash.slice(1));
  if (initialDetails?.tagName === 'DETAILS') initialDetails.open = true;
})();
